import { Component, OnInit } from "@angular/core";

import { CutoffService } from "../../../services/cutoff.service";
import { TicketService } from "../../../services/ticket.service";
import { SecurityService } from "../../../services/security.service";

import {
  TicketCutoffHistory,
  TicketCutoffType,
} from "../ticket-cutoff-type.model";
import { AccountManager } from "../../../model/domain/AccountManager";
import { Fund } from "../../../model/domain/Fund";

@Component({
  selector: "app-cutoff-exception-history",
  templateUrl: "./cutoff-exception-history.component.html",
  styleUrls: ["./cutoff-exception-history.component.css"],
})
export class CutoffExceptionHistoryComponent implements OnInit {
  constructor(
    private cutoffService: CutoffService,
    private ticketService: TicketService,
    private securityService: SecurityService
  ) {}

  historyResult: TicketCutoffHistory[];
  cutoffHistoryFilteredList: TicketCutoffHistory[];

  cutoffTypeListAll: TicketCutoffType[];
  cutoffTypeRegisteredList: TicketCutoffType[];
  cutoffTypeListToFilter: TicketCutoffType[];
  cutoffTypeSelected: number;

  accountManagerIdList: number[] = [];

  accountManagerListAll: AccountManager[];
  accountManagerListResult: AccountManager[];
  accountManagerRegisteredList: AccountManager[];
  accountManagerListToFilter: AccountManager[];
  accountManagerSelected: number;

  fundListAll: Fund[];
  fundListResult: Fund[];
  fundRegisteredList: Fund[];
  fundListToFilter: Fund[];
  fundSelected: number;

  displayedColumns = [
    "creationDate",
    "creationUser",
    "cutoffType",
    "accountManagerName",
    "fundName",
    "defaultLimitTime",
    "justificative",
  ];

  ngOnInit() {
    this.cutoffService.listCutoffType().subscribe((res) => {
      this.cutoffTypeListAll = res;
    });
    this.securityService.GetAccountManagers().subscribe((res) => {
      this.accountManagerListAll = res;

      this.includeAllInFilter();

      this.getHistory();
    });
  }

  getHistory() {
    this.cutoffService.listExceptionHistory(0, 0, 0).subscribe((res) => {
      this.historyResult = res;
      this.cutoffHistoryFilteredList = this.historyResult;

      if (this.historyResult.length > 0) {
        for (const item of this.historyResult) {
          if (this.cutoffTypeRegisteredList == null) {
            this.cutoffTypeRegisteredList = [];
          }
          if (
            !this.cutoffTypeRegisteredList.some(
              (x) => x.id === item.ticketCutoffType.id
            )
          ) {
            this.cutoffTypeRegisteredList.push(item.ticketCutoffType);
          }

          if (item.accountManagerId != null) {
            const accountManager = this.accountManagerListAll.find(
              (x) => x.id === item.accountManagerId
            );

            if (this.accountManagerRegisteredList == null) {
              this.accountManagerRegisteredList = [];
            }
            if (
              !this.accountManagerRegisteredList.some(
                (x) => x.id === accountManager.id
              )
            ) {
              this.accountManagerRegisteredList.push(accountManager);
            }

            item.accountManagerName = accountManager.name;
          } else {
            item.accountManagerName = "(todas)";
          }
        }

        this.cutoffTypeListToFilter = this.cutoffTypeRegisteredList;

        this.accountManagerListToFilter =
          this.accountManagerListToFilter.concat(
            this.accountManagerRegisteredList
          );
        this.accountManagerIdList = this.accountManagerRegisteredList.map(
          (x) => x.id
        );

        this.ticketService
          .getFundsByAccountManagerIdList(this.accountManagerIdList)
          .subscribe((result) => {
            this.fundListAll = result;
            for (const item of this.historyResult) {
              if (item.fundId != null) {
                const fund = this.fundListAll.find((x) => x.id === item.fundId);

                if (this.fundRegisteredList == null) {
                  this.fundRegisteredList = [];
                }
                if (
                  !this.fundRegisteredList.some((x) => x.id === item.fundId)
                ) {
                  this.fundRegisteredList.push(fund);
                }

                item.fundName = fund.name;
              } else {
                item.fundName = "(todos)";
              }
            }
            if (this.fundRegisteredList != null) {
              this.fundListToFilter = this.fundListToFilter.concat(
                this.fundRegisteredList
              );
            }
          });
      }
    });
  }

  applyFilter() {
    this.cutoffHistoryFilteredList = this.historyResult;

    if (this.cutoffTypeSelected != null) {
      const cutoffTypeId = this.cutoffTypeSelected;
      this.cutoffHistoryFilteredList = this.cutoffHistoryFilteredList.filter(
        function (obj) {
          return obj.ticketCutoffType.id === cutoffTypeId;
        }
      );
    }

    if (this.accountManagerSelected != null) {
      const accountManagerId = this.accountManagerSelected;
      if (this.accountManagerSelected > 0) {
        this.cutoffHistoryFilteredList = this.cutoffHistoryFilteredList.filter(
          function (obj) {
            return obj.accountManagerId === accountManagerId;
          }
        );
      } else if (this.accountManagerSelected === -1) {
        this.cutoffHistoryFilteredList = this.cutoffHistoryFilteredList.filter(
          function (obj) {
            return obj.accountManagerId === null;
          }
        );
      }
    }

    if (this.fundSelected != null) {
      const fundId = this.fundSelected;
      if (this.fundSelected > 0) {
        this.cutoffHistoryFilteredList = this.cutoffHistoryFilteredList.filter(
          function (obj) {
            return obj.fundId === fundId;
          }
        );
      } else if (this.fundSelected === -1) {
        this.cutoffHistoryFilteredList = this.cutoffHistoryFilteredList.filter(
          function (obj) {
            return obj.fundId === null;
          }
        );
      }
    }

    this.updateFilterItems();
  }

  updateFilterItems() {
    if (!this.cutoffTypeSelected) {
      const cutoffFilterItems: TicketCutoffType[] = [];
      const cutoffList = this.cutoffHistoryFilteredList.map(
        (x) => x.ticketCutoffType
      );

      for (const item of cutoffList) {
        if (!cutoffFilterItems.some((x) => x.id === item.id)) {
          cutoffFilterItems.push(item);
        }
      }
      this.cutoffTypeListToFilter = cutoffFilterItems;
    }

    if (!this.accountManagerSelected) {
      const accountManagerFilterItems: AccountManager[] = [];
      const accountManagerIdList = this.cutoffHistoryFilteredList.map(
        (x) => x.accountManagerId
      );

      if (accountManagerIdList.some((x) => x === null)) {
        const accountManagerAll: AccountManager = {
          id: -1,
          name: "(todas)",
          document: null,
        };
        accountManagerFilterItems.push(accountManagerAll);
      }

      for (const item of accountManagerIdList) {
        if (item === null) {
        } else if (!accountManagerFilterItems.some((x) => x.id === item)) {
          accountManagerFilterItems.push(
            this.accountManagerRegisteredList.find((x) => x.id === item)
          );
        }
      }
      this.accountManagerListToFilter = accountManagerFilterItems;
    }

    if (!this.fundSelected) {
      const fundFilterItems: Fund[] = [];
      const fundIdList = this.cutoffHistoryFilteredList.map((x) => x.fundId);

      if (fundIdList.some((x) => x === null)) {
        const fundAll: Fund = new Fund();
        fundAll.id = -1;
        fundAll.name = "(todos)";
        fundFilterItems.push(fundAll);
      }

      for (const item of fundIdList) {
        if (item === null) {
        } else if (!fundFilterItems.some((x) => x.id === item)) {
          fundFilterItems.push(
            this.fundRegisteredList.find((x) => x.id === item)
          );
        }
      }
      this.fundListToFilter = fundFilterItems;
    }
  }

  includeAllInFilter() {
    this.accountManagerListToFilter = [];
    const accountManagerAll: AccountManager = {
      id: -1,
      name: "(todas)",
      document: null,
    };
    this.accountManagerListToFilter.push(accountManagerAll);

    this.fundListToFilter = [];
    const fundAll: Fund = new Fund();
    fundAll.id = -1;
    fundAll.name = "(todos)";
    this.fundListToFilter.push(fundAll);
  }
}
